import React from "react";
import CookieConsent from "react-cookie-consent";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../common/constants";

/**
 * Cookie同意メッセージを表示します
 * @returns Cookie同意メッセージ
 */
export default function CookieConsentMessage() {
  const { t } = useTranslation();
  const IsCloud = AppConfig.MODE === AppConfig.MODE_CLOUD;
  const cookieName = AppConfig.COOKIE_CONSENT_COOKIE_NAME;

  return IsCloud ? (
    <CookieConsent
      cookieName={cookieName}
      buttonText={t("cookie_consent_button")}
    >
      {t("cookie_consent_message")}
    </CookieConsent>
  ) : (
    <div />
  );
}
